import React from "react";
import { Icon } from "@common/index";

interface DrawerPanelProps {
    testId: string;
    onBack: () => void;
    children: React.ReactNode;
}

export const DrawerPanel = ({ testId, onBack, children }: DrawerPanelProps) => (
    <div data-testid={testId}>
        <button
            type="button"
            onClick={onBack}
            aria-label="Back"
            className="w-full flex items-center gap-2 px-4 py-3 font-bold hover:bg-base-200"
        >
            <Icon name="chevron_left" className="text-xl" />
            <span>Back</span>
        </button>
        {children}
    </div>
);
